module.exports = __webpack_public_path__ + "static/media/card-logo-2.15c850de.svg";